import React, { useEffect } from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import CompanyTimeline from './components/CompanyTimeline';
import ArtisanProfiles from './components/ArtisanProfiles';
import PhilosophySection from './components/PhilosophySection';
import CertificationsSection from './components/CertificationsSection';
import VirtualShowroomSection from './components/VirtualShowroomSection';
import TestimonialsSection from './components/TestimonialsSection';
import DownloadableGuideSection from './components/DownloadableGuideSection';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "Sobre Nós - PH Móveis Artesanais",
    "description": "Conheça a história da PH Móveis Artesanais, nossos mestres artesãos e nossa filosofia de criar móveis únicos que contam histórias.",
    "url": "https://phmoveis.com.br/about-us",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "PH Móveis Artesanais",
      "foundingDate": "1999",
      "description": "Há 25 anos criando móveis únicos que transformam casas em lares, combinando tradição artesanal brasileira com design contemporâneo.",
      "numberOfEmployees": "15-20",
      "slogan": "Tradição em cada detalhe"
    }
  };

  return (
    <>
      <SEO
        title="Sobre Nós | Tradição e Excelência em Marcenaria"
        description="Conheça a história da PH Móveis Artesanais, nossos mestres artesãos e nossa filosofia de criar móveis únicos que contam histórias. 25 anos de tradição em marcenaria brasileira."
        keywords="sobre ph móveis, história marcenaria, artesãos brasileiros, móveis artesanais, tradição, qualidade, sustentabilidade, empresa familiar, marcenaria artesanal, móveis personalizados"
        image="https://phmoveis.com.br/assets/about-us-og.jpg"
        url="https://phmoveis.com.br/about-us"
        type="website"
        structuredData={structuredData}
      />
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16 lg:pt-20">
          {/* Hero Section */}
          <HeroSection />
          
          {/* Company Timeline */}
          <CompanyTimeline />
          
          {/* Philosophy Section */}
          <PhilosophySection />
          
          {/* Artisan Profiles */}
          <ArtisanProfiles />
          
          {/* Certifications Section */}
          <CertificationsSection />
          
          {/* Virtual Showroom */}
          <VirtualShowroomSection />
          
          {/* Testimonials */}
          <TestimonialsSection />
          
          {/* Downloadable Guide */}
          <DownloadableGuideSection />
        </main>

        {/* Footer */}
        <footer className="bg-primary text-primary-foreground py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="md:col-span-2">
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center">
                    <span className="text-accent-foreground font-bold">PH</span>
                  </div>
                  <div>
                    <div className="font-playfair font-bold text-xl">PH Móveis Artesanais</div>
                    <div className="text-sm opacity-80">Tradição em cada detalhe</div>
                  </div>
                </div>
                <p className="text-primary-foreground/80 leading-relaxed mb-6 max-w-md">
                  Há 25 anos criando móveis únicos que transformam casas em lares, 
                  combinando tradição artesanal brasileira com design contemporâneo.
                </p>
                <div className="text-sm text-primary-foreground/60">
                  © {new Date()?.getFullYear()} PH Móveis Artesanais. Todos os direitos reservados.
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-playfair font-bold text-lg mb-4">Links Rápidos</h4>
                <ul className="space-y-2 text-primary-foreground/80">
                  <li><a href="/homepage" className="hover:text-accent transition-colors">Início</a></li>
                  <li><a href="/interactive-catalog" className="hover:text-accent transition-colors">Catálogo</a></li>
                  <li><a href="/artisanal-process" className="hover:text-accent transition-colors">Processo</a></li>
                  <li><a href="/project-gallery" className="hover:text-accent transition-colors">Galeria</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h4 className="font-playfair font-bold text-lg mb-4">Contato</h4>
                <div className="space-y-3 text-primary-foreground/80">
                  <div className="text-sm">
                    <div className="font-medium">Showroom São Paulo</div>
                    <div>Rua Augusta, 1234 - Consolação</div>
                  </div>
                  <div className="text-sm">
                    <div className="font-medium">Telefone</div>
                    <div>(62) 99326-3202</div>
                  </div>
                  <div className="text-sm">
                    <div className="font-medium">WhatsApp</div>
                    <div>(62) 99326-3202</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AboutUs;